const common = {
  app: {
    name: "Qubiq",
  },
  auth: {
    signIn: "Entrar",
    signUp: "Criar conta",
    signInShort: "Entrar",
    signUpShort: "Inscrição",
  },
  landing: {
    firstMessageBefore: "Vê ",
    firstMessageHighlight: "onde os teus amigos estiveram",
    firstMessageAfter: " hoje.",
    secondMessageBefore: "Joga com os teus amigos no ",
    secondMessageHighlight: "mundo real.",
  },
  search: {
    placeholder: "Encontra o que quiseres...",
    ariaLabel: "Pesquisar",
  },
  feed: {
    untitled: "Sem título",
    channelFallback: "Canal",
    todayMomentsSubtitle: "Descobre onde os teus amigos passam os seus melhores momentos",
    todayMomentsLabel: "O Teu Momento",
    friendSpotsSection: "Os spots dos teus amigos",
    spotDistancePrefix: "A",
    loadMoreSpots: "Ver mais",
    nearbyExploreTitle: "Explora perto de ti",
    nearbyTreasureHuntsTitle: "Quests IRL",
    treasureHuntLabel: "Quest IRL",
    treasureHuntUnlockOnSite: "Quest IRL para desbloquear no local",
    unlockOnSite: "Para desbloquear no local",
    distanceAway: "A {{distance}}",
    mapFoundContent: "Conteúdo encontrado",
    mapNoExploreFound: "Nenhum Explore encontrado",
    openAction: "Abrir",
    startAction: "Começar",
    trendingNow: "Eles estão em alta neste momento",
    categoriesTitle: "Categorias",
  },
  video: {
    gameAvailable: "Jogo disponível neste vídeo",
    clickToPlay: "Clica para jogar",
    tapToPlay: "Toca para jogar",
    home: "Início",
    signInToLike: "Inicia sessão para gostar",
    signInToComment: "Inicia sessão para comentar",
    exploreOnlyFromMap: "Os Explores só podem ser abertos a partir do mapa ou da secção dedicada.",
    enableLocationForExplore: "Ativa a tua localização para ver este conteúdo Explore.",
    noAnswer: "Sem resposta",
    youtubeLikesUnavailable: "Os likes não estão disponíveis em vídeos do YouTube",
    addComment: "Adicionar um comentário...",
  },
  gameTypes: {
    quizShort: "Quiz",
    shortAnswerShort: "Resposta rápida",
  },
  badges: {
    wood: "Madeira",
    bronze: "Bronze",
    silver: "Prata",
    gold: "Ouro",
    uranium: "Urânio",
  },
  notifications: {
    title: "Notificações",
    loading: "A carregar notificações...",
    empty: "Ainda não há notificações.",
    signInRequired: "Inicia sessão para veres as tuas notificações.",
    loadError: "Não foi possível carregar as notificações.",
    userFallback: "Utilizador",
  },
  searchFeed: {
    all: "Tudo",
    spots: "Spots",
    videos: "Vídeos",
    explores: "Explores",
    treasureHunts: "Quests IRL",
    resultsFor: "Resultados para:",
    noResults: "Nenhum resultado encontrado.",
    availableAt: "Disponível a {{distance}}",
    unlockOnSite: "Desbloquear no local",
    channels: "Canais",
  },
  map: {
    filters: {
      subscriptions: "Assinaturas",
      private: "Privados",
      all: "Tudo",
    },
    myPosition: "Minha posição",
    searchPlacePlaceholder: "Procura Paris, Montmartre...",
    geolocationUnavailable: "A geolocalização não está disponível neste dispositivo.",
    enableLocationNearby: "Autoriza a geolocalização para desbloquear conteúdos próximos.",
    currentPositionUnavailable: "Não foi possível obter a tua posição atual.",
    googleMapsLoadError: "Não foi possível carregar o Google Maps.",
    loadExploreSubscriptionsError: "Não foi possível carregar as assinaturas Explore.",
    loadExplorePointsError: "Não foi possível carregar os pontos Explore.",
    loadExploreMapError: "Não foi possível carregar o mapa Explore.",
    loadPointDetailError: "Não foi possível carregar o detalhe do ponto.",
    loadTreasureHuntError: "Não foi possível carregar esta missão IRL.",
    noPlaceFound: "Nenhum lugar encontrado para esta pesquisa.",
    placeNotFound: "Lugar não encontrado.",
    enableCurrentPositionBeforeSaving: "Ativa a tua posição atual antes de guardar um ponto.",
    savePositionError: "Não foi possível guardar esta posição.",
    positionUsableForContent: "A posição pode ser usada para conteúdo",
    positionSaveFailed: "Não foi possível guardar a posição.",
    stopTreasureHuntError: "Não foi possível parar esta missão IRL.",
    gpsPointLabelPlaceholder: "Etiqueta do ponto GPS",
  },
  explore: {
    signInToInteract: "Inicia sessão para interagir com este explore.",
    likeError: "Não foi possível dar like neste explore.",
    addCommentError: "Não foi possível adicionar o comentário.",
    addReplyError: "Não foi possível adicionar a resposta.",
    likeCommentError: "Não foi possível dar like neste comentário.",
    requestSent: "Pedido enviado",
  },
  profileMenu: {
    title: "Perfil Qubiq",
    signedOutDescription:
      "Inicia sessão para aceder ao teu perfil, às tuas notificações e às funcionalidades de jogador e criador da Qubiq.",
    myProfile: "O meu perfil",
    editProfile: "Editar o meu perfil",
    notifications: "Notificações",
    notificationsWithCount: "Notificações ({{count}})",
    friendGroups: "Grupos de amigos",
    inviteFriends: "Convidar os meus amigos",
    inviteFriendsDesktop: "Convidar os meus amigos (+20 fichas qubs)",
    createOnQubiq: "Criar na Qubiq",
    contactUs: "Contactar-nos",
    creatorWelcomeTitle: "Agora és criador da Qubiq 💛",
    creatorWelcomeDesktop:
      "Clica no botão Qubiq Studio para carregares os teus vídeos e Explores, e configurares os teus jogos e missões.",
    creatorWelcomeMobile:
      "Toca no botão Qubiq Studio para carregares os teus vídeos e Explores, e configurares os teus jogos e missões.",
    contactCreatorMessage:
      "Envia-me um email para damien@qubiq.tv. Respondo-te o mais depressa possível 💛",
    legalInfo: "Informações legais",
    language: "Idioma",
    languageDescription: "Escolhe o idioma utilizado na Qubiq.",
    cookiesAndConsent: "Cookies e consentimento",
    manageCookies: "Gerir os meus cookies",
    openLanguageMenu: "Abrir seleção de idioma",
  },
  friendGroups: {
    title: "Grupos de amigos",
    subtitle: "Cria um grupo e convida outros jogadores a juntarem-se.",
    signInRequired: "Inicia sessão para aceder aos teus grupos de amigos.",
    loadError: "Não foi possível carregar os grupos de amigos.",
    detailLoadError: "Não foi possível carregar este grupo de amigos.",
    create: "+ Criar um grupo",
    createDialogTitle: "Criar um grupo de amigos",
    renameDialogTitle: "Renomear grupo",
    groupNameLabel: "Nome do grupo",
    groupNamePlaceholder: "Ex. Team Paris",
    confirmCreate: "Criar grupo",
    confirmRename: "Guardar",
    createError: "Não foi possível criar este grupo.",
    renameError: "Não foi possível renomear este grupo.",
    duplicateNameError: "Este nome de grupo já existe.",
    myGroups: "Os meus grupos",
    backToGroups: "Voltar aos grupos",
    empty: "Ainda não tens grupos de amigos.",
    untitledGroup: "Grupo sem nome",
    groupCounts: "{{count}} amigo(a)(s) · {{pending}} pedido(s) enviado(s)",
    incomingInvitesTitle: "Convites recebidos",
    invitedBy: "Convidado por {{username}}",
    accept: "Confirmar",
    refuse: "Cancelar",
    refuseInviteAction: "Recusar",
    acceptInviteError: "Não foi possível aceitar este convite.",
    refuseInviteError: "Não foi possível recusar este convite.",
    selectGroup: "Escolhe um grupo",
    selectGroupDescription: "Seleciona um grupo à esquerda para veres os amigos e enviares novos convites.",
    searchUsersTitle: "Adicionar amigo(a)(s)",
    searchPlayersPlaceholder: "Pesquisar jogadores",
    searchResults: "Resultados",
    searching: "A pesquisar...",
    noSearchResults: "Nenhum utilizador encontrado.",
    membersTitle: "Membros do grupo",
    noMembersYet: "Ainda não há membros.",
    addUserDialogTitle: "Adicionar ao meu grupo de amigos?",
    addUserDialogBody: "Queres enviar um convite a {{username}}?",
    confirm: "Confirmar",
    cancel: "Cancelar",
    inviteError: "Não foi possível enviar este convite.",
    friendStatus: "Amigo(a)",
    meLabel: "Eu",
    requestSentStatus: "Pedido enviado",
    incomingInviteDialogTitle: "Entrar neste grupo de amigos?",
    incomingInviteDialogBody: "Queres entrar no grupo {{groupName}}?",
    leaveGroup: "Sair do grupo",
    leaveDialogTitle: "Sair do grupo",
    leaveDialogBody: "Podes sempre voltar mais tarde se alguém te voltar a convidar.",
  },
  inviteFriends: {
    pageTitle: "Convida os teus amigos",
    popupTitle: "Convida os teus amigos para a Qubiq",
    popupBodyBeforeReward: "Tu e o teu amigo ganham",
    popupBodyAfterReward: "quando ele se regista com o teu link.",
    messageLabel: "Mensagem",
    copyIconLabel: "Copiar",
    rewardLine: "20 qubs para o teu amigo e 20 qubs para ti",
    helper:
      "Escolhe contactos se o teu dispositivo permitir. Caso contrário, a Qubiq abre a partilha do teu dispositivo ou copia a mensagem.",
    cta: "Convidar os meus amigos",
    copyButton: "Copiar mensagem",
    copied: "Mensagem copiada",
    loadError: "Não foi possível preparar o teu link de convite.",
    actionError: "Não foi possível abrir o convite.",
  },
  cookieConsent: {
    bannerTitle: "A Qubiq usa cookies",
    bannerDescription:
      "Utilizamos rastreadores necessários ao funcionamento do serviço e, com o teu consentimento, cookies de medição de audiência para compreender melhor a utilização da Qubiq.",
    bannerDetails:
      "Podes aceitar, recusar ou personalizar as tuas escolhas. Recusar é tão simples como aceitar e poderás alterar as tuas preferências mais tarde.",
    customize: "Personalizar",
    refuseAll: "Recusar tudo",
    acceptAll: "Aceitar tudo",
    preferencesTitle: "Gerir os meus cookies",
    preferencesDescription:
      "Escolhe quais os rastreadores que podem ser utilizados na Qubiq. Os cookies necessários permanecem ativos para permitir o início de sessão, a segurança e as funções essenciais do serviço.",
    analyticsNotice:
      "O Google Analytics permanece desativado enquanto não aceitares a medição de audiência.",
    necessaryTitle: "Cookies necessários",
    necessaryDescription:
      "Início de sessão, segurança, estabilidade da sessão e funcionalidades técnicas indispensáveis.",
    analyticsTitle: "Medição de audiência",
    analyticsDescription:
      "Google Analytics 4 para medir tráfego, desempenho e utilização global da Qubiq.",
    marketingTitle: "Marketing",
    marketingDescription:
      "Categoria reservada para futuros usos de marketing. Mantém-se desativada por enquanto.",
    cancel: "Cancelar",
    saveChoices: "Guardar as minhas escolhas",
  },
  navigation: {
    profile: "Perfil",
    home: "Início",
    infoAndRules: "Informações e regras",
    creatorsShow: "Os nossos criadores dão espetáculo",
    explore: "Explore",
    rankings: "Classificações",
  },
  sidebar: {
    hangout: "Onde toda a gente anda",
    welcomeCommunity: "Bem-vindo à comunidade",
  },
  categories: {
    entertainment: "Entretenimento",
    quiz: "Quiz e revisão",
    science: "Divulgação científica",
    sport: "Desporto",
    esport: "Esport",
    music: "Música",
  },
  visibility: {
    public: "Pública",
    notListed: "Não listada",
    private: "Privada",
  },
  ranking: {
    rankingGeneral: "Classificação geral",
    progression: "Progressão",
    rankings: "Classificações",
    exploreRankings: "Classificações Explore",
    players: "Jogadores",
    channels: "Canais",
    loading: "A carregar classificação...",
    irlQuest: "Quest IRL",
    overall: "Geral",
    rules: {
      useCase: "Caso de uso",
      reward: "Recompensa",
      info: "Info",
      quizVictoryLabel: "Vitória Quiz",
      quizVictoryInfo: "Dado apenas uma vez por jogo.",
      questionAnswerVictoryLabel: "Vitória Pergunta Resposta",
      questionAnswerVictoryInfo: "Dado apenas uma vez por jogo.",
      defeatLabel: "Derrota",
      defeatInfo: "Se houver timeout: 0 XP",
      questCompletedLabel: "Quest concluída",
      questCompletedInfo: "Dado em cada conclusão de quest",
      creatorGamePlayLabel: "Jogo jogado no teu conteúdo",
      creatorGamePlayInfo: "Dado apenas uma vez por tripla criador, jogo e jogador, vitória ou derrota",
      exploreLikeReceivedLabel: "Like no teu explore",
      exploreLikeReceivedInfo: "Dado apenas uma vez por utilizador e por explore",
      exploreViewReceivedLabel: "Vista no teu explore",
      exploreViewReceivedInfo: "Dado por cada nova sessão qualificada",
    },
  },
  profile: {
    notFound: "Perfil não encontrado.",
    loadError: "Não foi possível carregar este perfil.",
    signInToSubscribe: "Inicia sessão para subscrever.",
    subscribeFailed: "A subscrição falhou.",
    deletePostFailed: "Não foi possível apagar esta publicação.",
    likePostFailed: "Não foi possível gostar desta publicação.",
    updateQubsVisibilityFailed: "Não foi possível atualizar a visibilidade dos qubs.",
    videos: "Vídeos",
    explores: "Explores",
    treasureHunts: "Quests IRL",
    history: "Histórico",
    wallet: "Wallet",
    noVideosWatched: "Ainda não viste nenhum vídeo.",
    viewedDuration: "Visto {{duration}}",
  },
  bannerCounter: {
    loadError: "Não foi possível carregar a wallet.",
    offline: "offline",
  },
  studio: {
    explorePublicGpsRequired: "Associa este Explore a uma localização GPS antes de o tornar público.",
    explorePrivateGpsRequired: "Associa este Explore a uma localização GPS antes de conceder acesso privado.",
    title: "Qubiq Studio",
    createAction: "Criar",
    viewChannel: "Ver o meu perfil",
    subtitle: "Gere o teu canal, faz upload dos teus vídeos e configura os teus jogos",
    loading: "A carregar...",
    signInRequired: "Inicia sessão para aceder ao Studio.",
    channel: "Canal",
    profile: "Editar o meu perfil",
    questsAndExplores: "Missões e Explores",
    videos: "Vídeos",
    explores: "Explores",
    exploresDescription:
      "Os Explores são vídeos curtos que podes colocar em locais precisos.\n\nGuarda a posição GPS de um lugar que descobres e depois esconde lá um Explore ou uma etapa de uma Quest IRL.",
    treasureHunts: "Quests IRL",
    myChannel: "O meu canal",
    archives: "Arquivo",
    statusUploading: "Upload em curso",
    statusProcessing: "Tratamento",
    statusReady: "Pronta",
    statusError: "Erro",
    gpsPosition: "Posição GPS",
    manageGpsPoints: "Gerir os meus pontos GPS",
    manageGpsPointsDescription: "Encontra, muda o nome e elimina as posições GPS guardadas para os teus Explores.",
    backToExplores: "Voltar aos Explores",
    gpsPointSearchPlaceholder: "Procurar um ponto GPS pelo nome",
    gpsPointLabel: "Nome do ponto GPS",
    unnamedGpsPoint: "Ponto GPS sem nome",
    noGpsPoints: "Ainda não tens pontos GPS guardados.",
    noGpsPointSearch: "Nenhum ponto GPS corresponde a esta pesquisa.",
    gpsPointInUse: "Utilizado por {{count}} Explore(s)",
    gpsPointUnused: "Este ponto não é utilizado por nenhum Explore.",
    deleteGpsPoint: "Eliminar ponto",
    gpsPointDeleteQuestion: "Eliminar definitivamente \"{{label}}\"?",
    gpsPointDeleteBlocked: "Este ponto é utilizado por {{count}} Explore(s). Remove-o desses Explores antes de o eliminar.",
    loadMoreGpsPoints: "Ver mais pontos",
    gpsPointsCount: "{{count}} ponto(s) GPS",
    gpsMapUnavailable: "A pré-visualização do Maps não está disponível. As coordenadas continuam visíveis acima.",
    laptop: "Laptop",
    tablet: "Tablet",
    smartphone: "Smartphone",
    durationCheckError: "Não foi possível verificar a duração deste vídeo.",
    uploadFinishedProcessing: "Upload concluído. O processamento de qualidade e a codificação estão em curso.",
    verticalPreviewInfo: "Só é mostrada uma pré-visualização vertical para Explores.",
    noFileSelected: "Nenhum ficheiro selecionado",
    profileSaved: "Perfil do canal guardado.",
    profileSaveError: "Não foi possível guardar o perfil do canal.",
    loadVideosError: "Não foi possível carregar os vídeos.",
    loadChannelError: "Não foi possível carregar o canal.",
    archiveUpdateError: "Não foi possível atualizar o arquivo.",
    loadGpsPositionsError: "Não foi possível carregar as posições GPS.",
    gpsPositionUsed: "Posição GPS utilizada",
    gpsPositionRemoved: "Posição GPS removida",
    editDetails: "Editar detalhes",
    noAuthorizedEmail: "Nenhum email autorizado por enquanto.",
    exploreGpsPosition: "Posição GPS do teu Explore",
    activeGpsPosition: "Posição GPS ativa",
    removeGpsPosition: "Remover posição GPS",
    quizFirstTwoAnswersRequired: "As duas primeiras respostas são obrigatórias para {{game}}.",
    chooseCorrectAnswer: "Escolhe a resposta certa.",
    correctAnswerMustBeFilled: "A resposta certa deve apontar para uma resposta preenchida.",
    shortAnswerRequired: "A resposta certa é obrigatória para {{game}}.",
    configureChannel: "Configurar o meu canal",
    profilePhotoAlt: "Foto de perfil",
    firstName: "Primeiro nome",
    lastName: "Apelido",
    username: "Nome de utilizador",
    bio: "Bio",
    channelName: "Nome do teu canal",
    channelNameHelper: "Obrigatório para enviar um vídeo.",
    channelDescription: "Descrição do teu canal",
    statusLabel: "Estado",
    draftStatus: "Rascunho",
    publishedStatus: "Publicada",
    authorizedEmailsLabel: "Emails autorizados",
    authorizedEmailsHelper: "Um email por linha ou separados por vírgulas.",
    titleLabel: "Título",
    categoryLabel: "Categoria",
    visibilityLabel: "Visibilidade",
    descriptionLabel: "Descrição",
    archivedVideosTab: "Vídeos",
    archivedExploresTab: "Explores",
    archivedVideoSearchPlaceholder: "Pesquisar um vídeo arquivado pelo título",
    archivedExploreSearchPlaceholder: "Pesquisar um Explore arquivado pelo título",
    videoSearchPlaceholder: "Pesquisar um vídeo pelo título",
    exploreSearchPlaceholder: "Pesquisar um Explore pelo título",
    removeFromArchives: "Retirar do arquivo",
    addVideo: "Adicionar um vídeo",
    addExplore: "Adicionar um Explore",
    refresh: "Atualizar",
    archive: "Arquivar",
    archiveVideoTitle: "Arquivar vídeo",
    archiveVideoQuestion: "Tens a certeza de que queres arquivar este vídeo?",
    archiveExploreQuestNotice: "Este Explore também será removido da sua Quest IRL atual.",
    archivedVideoSuccess: "Vídeo arquivado.",
    removedFromArchivesSuccess: "Vídeo retirado do arquivo.",
    searchArchivedThumbnailAlt: "Miniatura do vídeo",
    thumbnailFallback: "Miniatura",
    thumbnailUpdated: "Miniatura atualizada.",
    thumbnailUploadError: "Não foi possível enviar a miniatura.",
    uploadCancelled: "Upload cancelado.",
    chooseThumbnail: "Escolhe uma miniatura.",
    chooseImageFormat: "Escolhe uma imagem JPG, PNG ou WebP.",
    thumbnailMaxSize: "A miniatura deve ter no máximo 5 MB.",
    chooseProfilePhoto: "Escolhe uma foto de perfil.",
    profilePhotoMaxSize: "A foto de perfil deve ter no máximo 5 MB.",
    usernameRequired: "O nome de utilizador é obrigatório.",
    saveChannelError: "Não foi possível guardar o canal.",
    verificationCancelled: "Verificação cancelada. O perfil não foi alterado.",
    copied: "Copiado!",
    copyFailed: "Não foi possível copiar.",
    resolveEmailsError: "Não foi possível verificar os emails.",
    loadPrivateAccessError: "Não foi possível carregar os acessos privados.",
    privateAccessTitle: "Acesso privado ao vídeo",
    configurePrivateAccessTitle: "Configurar acessos privados",
    addEmailsError: "Não foi possível adicionar estes emails.",
    saveUsernameBeforeUpload: "Guarda um nome de utilizador antes de enviar um vídeo.",
    chooseVideoToUpload: "Escolhe um vídeo para enviar.",
    prepareUploadError: "Não foi possível preparar o upload.",
    uploadToServerError: "Não foi possível enviar para o servidor.",
    uploadToStorageError: "Não foi possível enviar para o armazenamento.",
    storageFailed: "O armazenamento do vídeo falhou.",
    postUploadPreparationError: "A preparação do vídeo após o upload falhou.",
    uploadFailed: "Upload falhou.",
    exploreMaxDuration: "Um Explore deve durar no máximo 3 minutos.",
    titleRequired: "O título é obrigatório.",
    chooseCategory: "Escolhe uma categoria.",
    chooseVisibility: "Escolhe uma visibilidade.",
    updateVideoError: "Não foi possível editar o vídeo.",
    videoUpdated: "Vídeo atualizado.",
    videoUpdateFailed: "Não foi possível atualizar o vídeo.",
    assignGpsPositionError: "Não foi possível associar esta posição GPS.",
    gpsPositionProximityInfo:
      "Este conteúdo só será visível para utilizadores próximos desta posição GPS.",
    geolocationUnavailable: "A geolocalização não está disponível neste dispositivo.",
    currentPositionUnavailable: "Não foi possível obter a tua posição atual.",
    saveCurrentPositionError: "Não foi possível guardar a posição atual.",
    useCurrentPositionError: "Não foi possível usar a posição atual.",
    gpsLabelUpdated: "Etiqueta GPS guardada.",
    gpsLabelUpdateError: "Não foi possível editar esta etiqueta.",
    removeGpsPositionError: "Não foi possível remover a posição GPS.",
    gpsPositionRestrictionRemoved:
      "Este conteúdo já não está reservado a utilizadores próximos da posição GPS.",
    viewVideo: "Ver vídeo",
    dateLabel: "Data",
    viewsLabel: "Visualizações",
    changeThumbnail: "Alterar miniatura",
    uploadThumbnail: "A enviar miniatura...",
    managePrivateAccess: "Gerir acessos privados",
    authorizedEmailsCount: "{{count}} email(s) autorizado(s)",
    saving: "A guardar...",
    updating: "A atualizar...",
    save: "Guardar",
    saveGame: "Guardar jogo",
    cancel: "Cancelar",
    addEmails: "Adicionar um ou mais emails",
    add: "Adicionar",
    validate: "Validar",
    privateAccessDescription:
      "Permite apenas utilizadores autenticados cujo email corresponda a esta lista.",
    videoLink: "Ligação do vídeo",
    copyVideoLink: "Copiar ligação do vídeo",
    accountNotFound: "Conta não encontrada",
    unlistedVideoTitle: "Vídeo não listado",
    unlistedVideoDescription:
      "Este vídeo não aparecerá no feed nem nas sugestões. Só estará acessível através da ligação direta.",
    exploreLocationHelp:
      "Os Explores estão ligados a um local. Apenas as pessoas que se aproximarem do teu Explore poderão abri-lo.",
    useGpsPosition: "Usar uma posição GPS",
    accessRadius: "Raio de acesso:",
    attachExploreToPlace: "Liga o teu Explore a um local.",
    viewsBeforeDisappearance: "Número de visualizações antes de desaparecer",
    noLimitHelper: "Deixa em branco se não quiseres limite.",
    oneViewPerUser: "Assinala para que este Explore só seja visível uma vez por utilizador",
    hiddenExactPosition:
      "Assinala para ocultar a posição exata até 100 m à volta do Explore",
    previewHelp:
      "Verifica o aspeto do vídeo e dos jogos em laptop, tablet e smartphone.",
    screenPreview: "Pré-visualização dos ecrãs",
    explorePreview: "Pré-visualização do Explore",
    fullScreen: "Ecrã inteiro",
    exitFullScreen: "Sair do ecrã inteiro",
    back: "Voltar",
    portraitView: "Vista vertical",
    landscapeView: "Vista horizontal",
    backToMyVideos: "Voltar aos meus vídeos",
    preparingVideo: "Preparação do vídeo",
    globalLabel: "Global",
    hardcoreMode: "Modo hardcore",
    hardcoreDescription:
      "No modo hardcore, o jogador duplica os ganhos a cada resposta correta. Os ganhos acumulam-se numa barra, mas um erro faz perder tudo.",
    understood: "Percebi",
    treasureHuntPrefix: "Quest IRL: {{title}}",
    gamesLoadError: "Não foi possível carregar os jogos.",
    gameScheduleOverlapAt:
      'Com "Vídeo em pausa" desativado, este jogo sobrepõe-se ao jogo agendado em {{time}}.',
    globalPauseDisableError:
      "Não foi possível desativar a pausa do vídeo globalmente: os jogos em {{left}} e {{right}} iriam sobrepor-se.",
    chooseGameType: "Escolhe um tipo de jogo.",
    invalidGameMoment: "Indica um momento válido no formato 00:00 ou 00:00:00.",
    gameEndAfterTimer: "O timecode final deve ser superior ou igual ao tempo do jogo.",
    gameMomentWithinDuration:
      "O momento do jogo deve estar dentro da duração do vídeo (máx. {{max}}).",
    gameEndWithinDuration:
      "O timecode final do jogo deve estar dentro da duração do vídeo (máx. {{max}}).",
    answerTimePositive: "Indica um tempo de resposta superior a 0 segundos.",
    gameStartBeforeVideoEnd:
      "O timecode inicial do jogo mais o temporizador deve terminar pelo menos {{margin}} segundos antes do fim do vídeo ({{max}}), para deixar tempo à animação e ao ganho.",
    gameMomentWithinDurationShort: "O momento do jogo deve estar dentro da duração do vídeo.",
    gameOverlapWithoutPause:
      'Este jogo sobrepõe-se a outro com a regra "Vídeo em pausa" desativada.',
    videoDurationUnavailable:
      "A duração do vídeo não está disponível. Espera pelo fim do tratamento antes de adicionar um jogo.",
    saveGameError: "Não foi possível guardar o jogo.",
    gameSaved: "Jogo guardado.",
    gameSaveFailed: "Não foi possível guardar o jogo.",
    applyGlobalSettingsOverlap:
      "Não foi possível aplicar estas definições: alguns jogos iriam sobrepor-se.",
    applyGlobalSettingsError: "Não foi possível aplicar as definições globais.",
    globalSettingsApplied: "Definições globais aplicadas.",
    configureGame: "Configurar {{game}}",
    editGame: "Editar {{game}}",
    gameMoment: "Momento",
    gameStartTimecode: "Timecode inicial",
    gameEndTimecode: "Timecode final",
    timeFormatHelper: "Usa 00:00 ou 00:00:00.",
    gameStartsAt: "O jogo começa neste momento.",
    gameEndsAt: "O jogo termina neste momento.",
    answerTime: "Tempo para responder",
    secondsToAnswer: "segundos para responder",
    timecodeReference: "Referência do timecode",
    gameStartReference: "Timecode inicial do jogo",
    gameEndReference: "Timecode final do jogo",
    question: "Pergunta",
    answerOne: "Resposta 1",
    answerTwo: "Resposta 2",
    answerThree: "Resposta 3",
    answerFour: "Resposta 4",
    correctAnswer: "Resposta certa",
    expectedAnswer: "Resposta esperada",
    expectedAnswerHelper: "A resposta do utilizador será normalizada antes da comparação.",
    successMessage: "Mensagem de sucesso",
    failureMessage: "Mensagem de erro",
    globalPauseModeActive: "Configuração global ativa: o modo de pausa é definido ao nível do vídeo",
    pauseVideoDuringGame: "Vídeo em pausa durante o jogo",
    hardcoreAnswersGlobal:
      "Modo hardcore ativo: as respostas múltiplas são definidas globalmente",
    allowMultipleAnswers: "Permitir várias respostas",
    hardcoreRegainGlobal: "Modo hardcore ativo: a recuperação é definida globalmente",
    enableMultipleAnswersFirst:
      "Ativa primeiro as respostas múltiplas para permitir a recuperação",
    allowRegainEachVictory: "Permitir recuperação em cada vitória",
    globalGameConfig: "Configuração global para os jogos deste vídeo",
    hardcoreWholeVideo: "Modo hardcore em todo o vídeo",
    pauseAllGames: "Vídeo em pausa em todos os jogos deste vídeo",
    pauseCannotDisable: "A pausa do vídeo não pode ser desativada de momento.",
    overlappingGamesWithoutPause: "Estes jogos sobrepor-se-iam sem pausa:",
    allowMultipleAnswersAllHardcore:
      "Permitir várias respostas em todos os jogos hardcore",
    allowRegainAllHardcore: "Permitir recuperação em todos os jogos hardcore",
    hardcoreGlobalAllocation:
      "O modo hardcore força a alocação global. O replay e a recuperação são configurados acima.",
    applyToAllGames: "Aplicar a todos os jogos",
    addGame: "Adicionar um jogo",
    removeGameError: "Não foi possível remover o jogo.",
    removeGameFailed: "Não foi possível eliminar o jogo.",
    gameDisabled: "Jogo desativado.",
    disableGame: "Desativar",
    irlQuestCardLabel: "Quest IRL",
    newTreasureHunt: "Nova Quest IRL",
    treasureHuntsLoadError: "Não foi possível carregar as Quests IRL.",
    treasureHuntCreated: "Quest IRL criada.",
    treasureHuntSaved: "Quest IRL guardada.",
    treasureHuntDeleted: "Quest IRL eliminada.",
    availableExploresLoadError: "Não foi possível carregar os Explores disponíveis.",
    exploresAddedToQuest: "Explores adicionados à Quest IRL.",
    reorderExploresError: "Não foi possível reordenar os Explores.",
    exploreRemovedFromQuest:
      "Explore retirado da Quest IRL. Volta a ficar visível no mapa normal se for público.",
    removeExploreFromQuestError: "Não foi possível retirar este Explore.",
    treasureHuntThumbnailUpdated: "Miniatura da Quest atualizada.",
    configureTreasureHunt: "Seleciona uma Quest IRL para a configurar.",
    treasureHuntName: "Nome da Quest",
    addExistingExplores: "Adicionar Explores existentes",
    noExploreInTreasureHunt: "Ainda não há nenhum Explore nesta Quest IRL.",
    noCategory: "Sem categoria",
    moveUp: "Subir",
    moveDown: "Descer",
    remove: "Retirar",
    savingTreasureHunt: "A guardar...",
    saveTreasureHunt: "Guardar Quest",
    delete: "Eliminar",
    treasureHuntsDescription:
      "As Quests IRL são percursos de Explores para fazer passo a passo.\n\nOs jogadores precisam de encontrar cada local e vencer os jogos em cada Explore para desbloquear todas as etapas.",
    createNewExplore: "Criar um novo Explore",
    createTreasureHunt: "Criar uma Quest IRL",
    searchTreasureHunt: "Pesquisar uma Quest pelo título",
    treasureHuntCount: "{{count}} Explore(s)",
    noTreasureHuntYet: "Ainda não há nenhuma Quest IRL.",
    noTreasureHuntSearch: "Nenhuma Quest IRL corresponde a esta pesquisa.",
    signInToStartTreasureHunt: "Inicia sessão para começar a quest.",
    replayable: "Rejogável",
    oneAttempt: "Uma tentativa",
    addExistingExploresTitle: "Adicionar Explores existentes",
    outsideMapWarning:
      "Os Explores já ligados a outra Quest IRL serão removidos da Quest atual.",
    loadingAvailableExplores: "A carregar Explores disponíveis...",
    noAvailableExplore: "Nenhum Explore disponível para adicionar.",
    deleteTreasureHuntTitle: "Eliminar Quest",
    deleteTreasureHuntDescription:
      "Esta ação elimina definitivamente a Quest IRL sem eliminar os Explores associados.",
    deleting: "A eliminar...",
  },
  languageDialog: {
    title: "Idioma",
    description:
      "Escolhe o idioma utilizado na Qubiq. Se o idioma do navegador não for suportado, a aplicação muda automaticamente para inglês.",
    close: "Fechar",
  },
  legalLinks: {
    terms: "Condições",
    legal: "Informação legal",
    privacy: "Privacidade",
    cookies: "Cookies",
    moderation: "Moderação",
  },
  languages: {
    fr: "Français",
    en: "English",
    es: "Español",
    de: "Deutsch",
    pt: "Português",
    it: "Italiano",
  },
};

export default common;
